import { Link } from "react-router-dom";
import { categories, mangas } from "@/mocks/manga";
import SectionHeader from "@/components/common/SectionHeader";

export default function CategorySection() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <SectionHeader
          title="按分类浏览漫画"
          subtitle="热血、恋爱、奇幻……找到你最爱的漫画类型"
          moreTo="/category/rexue"
          icon="ri-apps-2-line"
        />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((c) => {
            const count = mangas.filter((m) => m.categories.includes(c.name)).length;
            return (
              <Link
                key={c.slug}
                to={`/category/${c.slug}`}
                className="group flex flex-col items-center text-center gap-3 p-4 md:p-5 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50 transition-colors"
              >
                <span className="flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-background-50 border border-background-200 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={`${c.icon} text-2xl md:text-3xl`}></i>
                </span>
                <span className="text-sm md:text-base font-semibold text-foreground-900">{c.name}</span>
                <span className="text-xs text-foreground-500">{count} 部作品</span>
                <span className="hidden md:block text-xs text-foreground-500">{c.desc}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}